import { saveExcelSpreadsheet } from '@fluentsms/utils';
import { Column, Row } from 'react-table';
import { toWorkbook } from './mappers/toWorkbook';

export interface ExportToExcelProps<TRow extends Record<string, unknown>> {
  rows: Row<TRow>[];
  visibleColumns: Column<TRow>[];
  prepareRow: (row: Row<TRow>) => void;
  selectedRowIds: Record<string, boolean>;
  sheetName: string;
  fileName: string;
}

function exportToExcel<TRow extends Record<string, unknown>>(props: ExportToExcelProps<TRow>) {
  const { fileName } = props;

  const workbook = toWorkbook(props);

  saveExcelSpreadsheet({
    workbook,
    fileName: `${fileName}.xlsx`,
  });
}

export function useExportDataGridToExcel() {
  return {
    exportToExcel,
  };
}
